import request from '@/utils/request'

// 查询社区小组列表
export function listCommunityGroup(query) {
  return request({
    url: '/biz/admin/community/community/group/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组分页
export function pageCommunityGroup(query) {
  return request({
    url: '/biz/admin/community/community/group/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组详细
export function getCommunityGroup(data) {
  return request({
    url: '/biz/admin/community/community/group/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组
export function addCommunityGroup(data) {
  return request({
    url: '/biz/admin/community/community/group/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组
export function updateCommunityGroup(data) {
  return request({
    url: '/biz/admin/community/community/group/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组
export function delCommunityGroup(data) {
  return request({
    url: '/biz/admin/community/community/group/delete',
    method: 'post',
    data: data
  })
}
